import React from 'react';
import '../css/faq_section.css'


class FaqSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            banner_text: "",
            banner_img: "",
            list: []
        }
    }


    componentWillMount() {
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.faq !== undefined && this.props.context.faq !== "") {
                let banner_text = "常見問題";
                let banner_img = "";
                let list = [];

                if (this.props.context.faq.banner_text !== undefined) {
                    banner_text = this.props.context.faq.banner_text;
                }

                if (this.props.context.faq.banner_img !== undefined) {
                    banner_img = this.props.context.faq.banner_img;
                }

                if (this.props.context.faq.itemList !== undefined && this.props.context.faq.itemList.length) {
                    list = this.props.context.faq.itemList
                }



                this.setState({
                    banner_text: banner_text,
                    banner_img: banner_img,
                    list: list
                })

            }
        }
    }

    render() {

        let list;

        if (this.state.list !== undefined && this.state.list.length) {
            list = this.state.list.map((s1, i) => {

                if (s1.qTitle !== undefined && s1.qTitle.length) {
                    let items = s1.qTitle.map((q1, j) => {
                        if (q1.qList !== undefined && q1.qList.length) {

                            let img = q1.qList.map((li, g) => {
                                if (li.item_img !== undefined && li.item_img !== "") {
                                    return (
                                        <div id="delivery" className="delivery_img" key={g}>
                                            <img src={li.item_img} alt="" />
                                        </div>
                                    )
                                }
                            })

                            let li = q1.qList.map((li, k) => {
                                if (li.item_content !== undefined) {
                                    return (
                                        <li key={k}>{li.item_content}</li>
                                    )
                                }
                            })

                            return (
                                <div className="faq-seq" key={j}>
                                    <div className="faq_title"><i className="fa fa-sort-down"></i>{(q1.item_name !== undefined) ? q1.item_name : ""}</div>
                                   {img}
                                   <div className="faq_content">
                                        <ul>
                                            {li}
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                    })

                    return (
                        <div className="faq_content_wrap" key={i}>
                            <div className="faq_main_title">{(s1.qname !== undefined) ? s1.qname : ""}</div>
                            <div className="faq_line_1"></div>
                            {items}
                        </div>
                    )
                }
            })
        }



        return (
            <div className="faqsection-frame">
                <section>
                    <div className="secondary_banner_wrap">
                        <div>
                            <img src={this.state.banner_img} alt="" />
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">

                        <div className="">
                            <div className="intro_wrap_1">
                                <div className="intro_title_3">{this.state.banner_text}</div>
                                <div className="intro_content_line_2"></div>
                            </div>
                            {list}
                        </div>
                        <div className="info_line_1"></div>
                        <div className="info_line_2"></div>

                    </div>
                </section>
            </div>
        )
    }
}


export default FaqSection


// WEBPACK FOOTER //
// ./src/component/faqSection.js